import useSWR, { SWRConfiguration } from 'swr';
import { cmsApi } from '../base/cmsApi';
import api from '../base';
 
interface UseFetchApiType {
    url: string;
    service: "CMS_PROC" | "USER_PROC" | "NOTIFY_PROC";
    options?: SWRConfiguration;
}

const useFetchApi = ({
    url,
    service,
    options = {},
}: UseFetchApiType) => {
    

    const _getApi = () => {
        switch (service) {
            case "CMS_PROC":
                return cmsApi;
            default:
                return api;
        }
    }

    const {
        data,
        error,
        isLoading,
        isValidating,
        mutate,
    } = useSWR(url, _getApi(), options);
 

    return {
        data: (data as any)?.data,
        status: (data as any)?.status,
        error: error,
        isLoading: isLoading,
        isValidating: isValidating,
        mutate: mutate,
    };
}

export default useFetchApi;